import { updateInventoriesData, updateInventoriesDataLoaded } from "@App/userHistoryReducer";
import config from "@Config/index";
import axios from "axios";
import { Dispatch } from "react";

const fetchInventoriesUserHistoryData = async (dispatch: Dispatch<any>, id: number) => {
  try {
    dispatch(updateInventoriesDataLoaded(false));
    const response = await axios.get(
      `${config.API_URL}/api/v0/user_flow/inventory/${id}?fetch_details=true`,
      {
        withCredentials: true,
      },
    );

    if (response.data && response.data.message === "success") {
      dispatch(updateInventoriesData(response.data.data));
    }
    dispatch(updateInventoriesDataLoaded(true));
  } catch (error) {
    console.log("Error", error);
    dispatch(updateInventoriesDataLoaded(true));
  }
};

export default fetchInventoriesUserHistoryData;
